import React from "react";

import bustleStackedLockupBlue from "assets/images/bustle/StackedLockUpCoolBlueBigBVersion@0.5.png";
import { ReactComponent as PosBossCloud } from "assets/images/posBossCloud.svg";
import { Trans, useTranslation } from "react-i18next";

import Icon from "Atoms/Icons";
import { WithLoadingComponent } from "Atoms/Loading";

import { VenueErrorPage } from "./ErrorPage";

type windowVenueName = {
  venueName: string;
};
export const LoadingPage = () => {
  const { t } = useTranslation();
  const venueName = (window as { venueName?: string }).venueName;
  return (
    <div className="bg-bustle-cream overflow-y-hidden h-screen">
      <div className="flex flex-col overflow-y-auto mx-auto max-w-screen-sm w-full h-screen items-center justify-center space-y-48">
        <img
          src={bustleStackedLockupBlue}
          alt="Bustle"
          className="w-auto animate-small-bounce max-w-xs h-192"
        />
        <h3 className="text-xl text-center ">
          {venueName ? (
            <Trans
              i18nKey="common.loadingVenue"
              values={{ venueName }}
              shouldUnescape
            />
          ) : (
            t("common.loading")
          )}
        </h3>
      </div>
    </div>
  );
};

export const LoadingSpinner = ({ ...props }) => {
  return (
    <Icon
      color={undefined}
      size={undefined}
      icon="loading"
      className="animate-spin align-middle inline-block"
      {...props}
    />
  );
};

const Loading = WithLoadingComponent(
  () => (
    <div>
      <LoadingPage />
    </div>
  ),
  () => (
    <div>
      <VenueErrorPage resetError={() => {}} errorMessage="Error" />
    </div>
  ),
);
export const isLoading = (status: ("error" | "pending" | "success")[]) => {
  return status.some((s) => s === "pending");
};

export { useLoadingState } from "Atoms/Loading";
export default Loading;
